// Core
import React from "react";
import { Modal } from "react-bootstrap";

// Assets
import Logout from "../../Assets/Svg/Auth/Logout.svg";

// Styles
import "./styles.scss";

const LogoutModal = ({ show, onCancel, onLogout }) => {
  return (
    <Modal show={show} onHide={onCancel} centered size="sm">
      <Modal.Body>
        <div className="text-center">
          <div className="logout-icon">
            <img
              src={Logout}
              className="menu-icon"
              alt="logout"
              width="48"
              height="48"
            />
          </div>
          <div className="info">
            <h2 className="logout-heading">Logout</h2>
            <p className="text-logout">
              Are you sure you want to logout from the application?
            </p>
          </div>
          <div className="button-container">
            <button className="cancel-button" onClick={onCancel}>
              Cancel
            </button>
            <button className="logout-button" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
